'use client';
import React, { useEffect } from 'react';
import useUserStore from '@/store/useUserStore';
import Image from 'next/image';
import { DEFAULT_HEAD } from '@/common/constant';

interface Props {
    initStardust: any;
}

const stardustInfo = (balance: number, expiringThisMonth: number, usedThisMonth: number) => [
    { label: '持有星塵', value: balance, color: 'text-plum' },
    { label: '即將過期', value: expiringThisMonth, color: 'text-cobalt3' },
    { label: '本月消耗', value: usedThisMonth, color: 'text-cobalt3' },
];

const UserStardustInfo = ({ initStardust = {} }: Props) => {
    const { setUser, user } = useUserStore() || {};
    const { uid, image } = user || {};
    // balance 等欄位優先取 store（client 更新後的值），未更新前先用 server 端 initStardust，避免畫面先閃 0 才跳成正確數字
    const balance = user?.balance ?? initStardust.balance ?? 0;
    const expiringThisMonth = user?.expiringThisMonth ?? initStardust.expiringThisMonth ?? 0;
    const usedThisMonth = user?.usedThisMonth ?? initStardust.usedThisMonth ?? 0;

    useEffect(() => {
        setUser(initStardust);
    }, [uid, initStardust]);

    if (!uid) return null;

    return (
        <div className="select-none center-center bg-white rounded-lg py-1.5 gap-x-3 xl:hidden sm:gap-x-3.5">
            {/* 頭像 */}
            <div className="relative w-8.5 aspect-square overflow-hidden">
                <Image
                    src={image || DEFAULT_HEAD}
                    fill
                    className="object-cover rounded-full"
                    alt="avatar"
                />
            </div>

            {/* 星塵資訊列表 */}
            {stardustInfo(balance, expiringThisMonth, usedThisMonth).map(
                ({ label, value, color }, index, arr) => (
                    <React.Fragment key={label}>
                        <div
                            className={`text-bd3n text-black4 flex items-center ${
                                index === 2 ? 'hidden sm:flex' : ''
                            }`}
                        >
                            <p className="mr-1">{label}</p>
                            <p className={`${color} text-bd4n`}>{value.toLocaleString()}</p>
                        </div>

                        {/* 分隔線：最後一項不顯示 */}
                        {index < arr.length - 1 && (
                            <span
                                key={`divider-${label}`}
                                className={`w-px h-2.75 border-l border-black2/30 ${
                                    index === 1 ? 'hidden sm:block' : ''
                                }`}
                            />
                        )}
                    </React.Fragment>
                )
            )}
        </div>
    );
};

export default UserStardustInfo;
